import styled from 'styled-components';

import { TextButton } from '@xing-com/button';
import { mediaConfined, mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { scale000, spaceM, spaceS, spaceXXL } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

const HeaderWrapper = styled.div`
  @media ${mediaConfined} {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

const StyledBodyCopy = styled(BodyCopy)`
  margin: ${spaceM} ${scale000} ${spaceXXL};
`;

const StyledTextButton = styled(TextButton)`
  @media ${mediaSmallOrTiny} {
    margin-top: ${spaceS};
  }
`;

export const Styled = {
  HeaderWrapper,
  TextButton: StyledTextButton,
  BodyCopy: StyledBodyCopy,
};
